import type { IxcTrfV1TrfReportKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const TRF_REPORT_BASE_PATH = getResolvedPath('/clearing/operations/trade/trf-report');

export const getTrfReportPath: EntityPathBuilder<IxcTrfV1TrfReportKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return TRF_REPORT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.trfReportId) {
        return undefined;
      }

      return getResolvedPath(`${TRF_REPORT_BASE_PATH}/$trfReportId`, context.keys);
    }
  }
};

export function getTrfReportDetailPath(trfReportId: string | undefined) {
  if (!trfReportId) {
    return undefined;
  }

  return getTrfReportPath({ kind: 'detail', keys: { trfReportId } });
}
